import { Button, Stack, Typography } from "@mui/material";
import { Component, ErrorInfo, ReactNode } from "react";

interface RouteErrorBoundaryProps {
  children: ReactNode;
}

interface RouteErrorBoundaryState {
  error: Error | null;
}

class RouteErrorBoundary extends Component<
  RouteErrorBoundaryProps,
  RouteErrorBoundaryState
> {
  state: RouteErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): RouteErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Route rendering failed", error, info);
  }

  private retry = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <Stack
        role="alert"
        spacing={2}
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        px={2}
        textAlign="center"
      >
        <Typography variant="h5">This page could not be loaded.</Typography>
        <Typography color="text.secondary">
          Try reloading the page. If the problem continues, return later.
        </Typography>
        <Button variant="contained" onClick={this.retry}>
          Reload page
        </Button>
      </Stack>
    );
  }
}

export default RouteErrorBoundary;